import DeviceConfig from '@devices/config';
import FlavourConfig from '@shared/config/flavours';
import Languages from '@shared/types/enums/languages';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { SectionQueryInfo } from '@shared/types/interfaces/query';
import { store } from '@shared/store/store';

/******************/
/**     INFO     **/
/******************/

/**
 *
 * @param section Section identifier
 * @returns Sections query info
 */
export default function info(section: string): SectionQueryInfo {
  const { plans, user } = store.getState();
  const device = DeviceConfig.info.os.toUpperCase();
  let carrier = user.carrierId || FlavourConfig.carrierId || '';
  let language = TranslationManager.currentLanguage;
  let plan = user.planId || '';

  if (language === Languages.ORIGINAL || !language) {
    language = Languages.SPANISH;
  }

  if (user.isAnonymous) {
    carrier = FlavourConfig.carrierId;
    plan = plans.anonymous?.id || plan;
  }
  return {
    query: {
      carrier,
      device,
      language,
      plan,
      section,
    },
  };
}
